import React, { FC, useMemo, useState } from 'react';
import { Button, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { ElementSelector } from '../../../../components';
import { JSONForm } from '../../../../components/json-form/JSONForm';
import { Surcharge } from '../../../../models';
import { useTranslation } from '../../../../translations';
import { LocalSearchProvider } from '../utils';

interface Props {
  readonly categoryId: number;
  readonly open?: boolean;
  readonly onUpdate: () => void;
  readonly onCancel: () => void;
}

export const AssignCategorySurchargeModal: FC<Props> = ({
  categoryId,
  open,
  onCancel,
  onUpdate,
}) => {
  const { ts } = useTranslation();
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const memoizedSearchProvider = useMemo(
    () =>
      new LocalSearchProvider(async () =>
        (await api.getSurcharges()).filter(({ deletedAt }) => !deletedAt),
      ),
    [],
  );

  return (
    <Modal className="modal-large" id="assignSurchargeModal" isOpen={open}>
      <JSONForm<undefined, { surchargeIds: number[] }>
        id="assignSurchargeForm"
        method="post"
        onSuccess={onUpdate}
        path={`/api/products/categories/${categoryId}/surcharges`}
        preSubmit={(r) => (r.inputs.surchargeIds = selectedIds)}
      >
        <ModalHeader>{ts('assign_category_level_surcharges')}</ModalHeader>
        <ModalBody>
          <p>{ts('selected_surcharges_will_be_added')}</p>
          <p>{ts('if_a_category_level_surcharge')}</p>
          <hr />
          <FormGroup>
            <Label for="product">{ts('surcharge_search')}</Label>
            <ElementSelector<Surcharge>
              id="surchargesSelector"
              searchProvider={memoizedSearchProvider}
              selectionIdsChanged={setSelectedIds}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" disabled={selectedIds.length === 0} id="assignSurcharges">
            {ts('assign_surcharges')}
          </Button>
          <Button color="secondary" onClick={onCancel}>
            {ts('common.cancel')}
          </Button>
        </ModalFooter>
      </JSONForm>
    </Modal>
  );
};
